
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/iotdm/protocolDetail/page"
      getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('xieyimingxibianma')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('xieyimingximingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shifoujisuanzhi')">
            <el-select v-model="yt.conditions.calculated">
              <el-option :label="$t('shi')" :value="true"></el-option>
              <el-option :label="$t('fou')" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary"
              plain="plain">
              {{$t('sousuo')}}
            </el-button>
            <el-button @click="yt.clear({protocolId: protocol.id})">{{$t('chongzhi')}}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzengxieyimingxi',null,'w1')" type="primary">
          {{$t('xinzeng')}}
        </el-button>
        <el-button size="mini" @click="yt.showEditDialog('peizhixieyishebeicanshu',null,'40%'),loadParamsType()" type="primary">
          {{$t('peizhixieyishebeicanshu')}}
        </el-button>
        <el-button size="mini" @click="getLgTemplateData(),yt.showEditDialog('tongbulaogoumuban',null,'40%')" type="primary">
          {{$t('tongbulaogoumuban')}}
        </el-button>
      </template>

      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row,'w1'), splitParams(scope.row)">{{$t('bianji')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger"
              @click="yt.remove(scope.row,'/web/iotdm/protocolDetail/delete')">{{$t('shanchu')}}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
      :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzengxieyimingxi'">
        <div class="dialog-scroller">
        <el-form :inline="false" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('xieyimingxibianma')" required="required">
            <el-input v-model="yt.editObj.code" style="width: 30%;"></el-input>
          </el-form-item>
          <el-form-item :label="$t('xieyimingximingcheng')" required="required">
            <el-input v-model="yt.editObj.name" style="width: 30%;"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shujuleixing')" required="required">
            <el-select v-model="yt.editObj.dataType">
              <el-option :label="$t('zifuchuan')" :value="1"></el-option>
              <el-option :label="$t('fudian')" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('shifoujisuanzhi')" required="required">
            <el-select v-model="yt.editObj.calculated">
              <el-option :label="$t('shi')" :value="true"></el-option>
              <el-option :label="$t('fou')" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('jisuanleixing')" required="required">
            <el-select v-model="yt.editObj.calcType" @change="changeCalcType($event)">
              <el-option :label="$t('无')" :value="0"></el-option>
              <el-option :label="$t('加法')" :value="101"></el-option>
              <el-option :label="$t('乘法')" :value="102"></el-option>
              <el-option :label="$t('映射')" :value="103"></el-option>
              <el-option :label="$t('最大值')" :value="201"></el-option>
              <el-option :label="$t('累计产量/劣品数')" :value="301"></el-option>
              <el-option :label="$t('开合模次数')" :value="302"></el-option>
              <el-option :label="$t('模号/料号计算')" :value="304"></el-option>
              <el-option :label="$t('最后上线时间')" :value="305"></el-option>
              <el-option :label="$t('状态')" :value="306"></el-option>
              <el-option :label="$t('告警')" :value="307"></el-option>
              <el-option :label="$t('特殊告警IO')" :value="308"></el-option>
              <el-option :label="$t('八进制告警')" :value="309"></el-option>
              <el-option :label="$t('十进制告警')" :value="310"></el-option>
              <el-option :label="$t('十六进制告警')" :value="311"></el-option>
              <el-option :label="$t('一对多告警')" :value="312"></el-option>
              <el-option :label="$t('报警数告警')" :value="202"></el-option>
            </el-select>
          </el-form-item>
          <div v-if="yt.editObj.calcType > 0 && yt.editObj.calculated == true ">
            <div v-if="yt.editObj.calcType == 102 || yt.editObj.calcType == 101">
              <el-form-item :label="$t('jisuanyinzi')">
                <el-input v-model="calPointParams.factor" style="width: 80%;"  oninput ="value=value.replace(/[^0-9.]/g,'')"></el-input>
              </el-form-item>
            </div>
            <div v-if="yt.editObj.calcType == 201 || yt.editObj.calcType == 304 ">
              <el-form-item :label="$t('canshu')">
                <el-input v-model="calPointParams.args" style="width: 80%;"></el-input>
              </el-form-item>
            </div>
            <div v-if="yt.editObj.calcType == 202">
              <el-form-item :label="$t('canshu')">
                <el-input v-model="calPointParams.args" style="width: 80%;"></el-input>
              </el-form-item>
              <el-form-item :label="$t('baojingdeng')">
                <el-input v-model="calPointParams.alarm_lamp_point" style="width: 80%;"></el-input>
              </el-form-item>
              <el-form-item :label="$t('baojingshu')">
                <el-input v-model="calPointParams.alarm_count_point" style="width: 80%;"></el-input>
              </el-form-item>
            </div>
            <div v-if="yt.editObj.calcType == 103">
              <el-form-item :label="$t('xieyidianyingshe')">
                <el-input v-model="calPointParams.map" style="width: 80%;" type="textarea"
                    :rows="2" placeholder='Example：{"0": "1", "1": "2", "2": "3", "3": "4"}'></el-input>
              </el-form-item>
            </div>
            <div v-if="yt.editObj.calcType == 301 || yt.editObj.calcType == 302">
              <el-form-item :label="$t('chanliangdianbianma')">
                <el-input v-model="calPointParams.prod" style="width: 80%;"></el-input>
              </el-form-item>
              <el-form-item :label="$t('zhouqidianbianma')">
                <el-input v-model="calPointParams.cycle" style="width: 80%;"></el-input>
              </el-form-item>
              <el-form-item :label="$t('muxueshudianbianma')">
                <el-input v-model="calPointParams.cavity" style="width: 80%;"></el-input>
              </el-form-item>
              <el-form-item :label="$t('bianhuanshangxian')">
                <el-input v-model="calPointParams.upperLimit" style="width: 80%;"></el-input>
              </el-form-item>
            </div>
            <div v-if="yt.editObj.calcType == 306">
              <el-form-item :label="$t('kongxiandianbianma')">
                <el-input v-model="calPointParams.idle_point" style="width: 80%;"></el-input>
              </el-form-item>
              <el-form-item :label="$t('gaojingdianbianma')">
                <el-input v-model="calPointParams.event_point" style="width: 80%;"></el-input>
              </el-form-item>
            </div>
            <div v-if="yt.editObj.calcType == 307 || yt.editObj.calcType == 309 || yt.editObj.calcType == 310 || yt.editObj.calcType == 311 || yt.editObj.calcType == 312">
              <el-form-item :label="$t('xieyishijian')">
                <el-input v-model="calPointParams.events" style="width: 80%;" type="textarea"
                    :rows="5" placeholder='Example：{"24": {"code": "24", "type": 2}, "25": {"code": "25", "type": 1}}'></el-input>
              </el-form-item>
            </div>
            <el-form-item :label="$t('triggers')">
              <el-input v-model="calPointTriggers" style="width: 80%;" type="textarea"
                  :rows="5"></el-input>
            </el-form-item>
          </div>
        </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/iotdm/protocolDetail/create',beforeAdd)" type="primary">
            {{$t('baocun')}}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <div class="dialog-scroller">
        <el-form :inline="false" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('xieyimingxibianma')" required="required">
            <el-input disabled v-model="yt.editObj.code" style="width: 30%;"></el-input>
          </el-form-item>
          <el-form-item :label="$t('xieyimingximingcheng')" required="required">
            <el-input disabled v-model="yt.editObj.name" style="width: 30%;"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shujuleixing')" required="required">
            <el-select v-model="yt.editObj.dataType">
              <el-option :label="$t('zifuchuan')" :value="1"></el-option>
              <el-option :label="$t('fudian')" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('shifoujisuanzhi')" required="required">
            <el-select v-model="yt.editObj.calculated">
              <el-option :label="$t('shi')" :value="true"></el-option>
              <el-option :label="$t('fou')" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('jisuanleixing')" required="required">
            <el-select v-model="yt.editObj.calcType" @change="changeCalcType($event)">
              <el-option :label="$t('无')" :value="0"></el-option>
              <el-option :label="$t('加法')" :value="101"></el-option>
              <el-option :label="$t('乘法')" :value="102"></el-option>
              <el-option :label="$t('映射')" :value="103"></el-option>
              <el-option :label="$t('最大值')" :value="201"></el-option>
              <el-option :label="$t('累计产量/劣品数')" :value="301"></el-option>
              <el-option :label="$t('开合模次数')" :value="302"></el-option>
              <el-option :label="$t('模号/料号计算')" :value="304"></el-option>
              <el-option :label="$t('最后上线时间')" :value="305"></el-option>
              <el-option :label="$t('状态')" :value="306"></el-option>
              <el-option :label="$t('告警')" :value="307"></el-option>
              <el-option :label="$t('特殊告警IO')" :value="308"></el-option>
              <el-option :label="$t('八进制告警')" :value="309"></el-option>
              <el-option :label="$t('十进制告警')" :value="310"></el-option>
              <el-option :label="$t('十六进制告警')" :value="311"></el-option>
              <el-option :label="$t('一对多告警')" :value="312"></el-option>
              <el-option :label="$t('报警数告警')" :value="202"></el-option>
            </el-select>
          </el-form-item>
          <div v-if="yt.editObj.calcType > 0 && yt.editObj.calculated == true ">
            <div v-if="yt.editObj.calcType == 102 || yt.editObj.calcType == 101">
              <el-form-item :label="$t('jisuanyinzi')">
                <el-input v-model="calPointParams.factor" style="width: 80%;"  oninput ="value=value.replace(/[^0-9.]/g,'')"></el-input>
              </el-form-item>
            </div>
            <div v-if="yt.editObj.calcType == 201 || yt.editObj.calcType == 304 ">
              <el-form-item :label="$t('canshu')">
                <el-input v-model="calPointParams.args" style="width: 80%;"></el-input>
              </el-form-item>
            </div>
            <div v-if="yt.editObj.calcType == 202">
              <el-form-item :label="$t('canshu')">
                <el-input v-model="calPointParams.args" style="width: 80%;"></el-input>
              </el-form-item>
              <el-form-item :label="$t('baojingdeng')">
                <el-input v-model="calPointParams.alarm_lamp_point" style="width: 80%;"></el-input>
              </el-form-item>
              <el-form-item :label="$t('baojingshu')">
                <el-input v-model="calPointParams.alarm_count_point" style="width: 80%;"></el-input>
              </el-form-item>
            </div>
            <div v-if="yt.editObj.calcType == 103">
              <el-form-item :label="$t('xieyidianyingshe')">
                <el-input v-model="calPointParams.map" style="width: 80%;" type="textarea"
                    :rows="2" placeholder='Example：{"0": "1", "1": "2", "2": "3", "3": "4"}'></el-input>
              </el-form-item>
            </div>
            <div v-if="yt.editObj.calcType == 301 || yt.editObj.calcType == 302">
              <el-form-item :label="$t('chanliangdianbianma')">
                <el-input v-model="calPointParams.prod" style="width: 80%;"></el-input>
              </el-form-item>
              <el-form-item :label="$t('zhouqidianbianma')">
                <el-input v-model="calPointParams.cycle" style="width: 80%;"></el-input>
              </el-form-item>
              <el-form-item :label="$t('muxueshudianbianma')">
                <el-input v-model="calPointParams.cavity" style="width: 80%;"></el-input>
              </el-form-item>
              <el-form-item :label="$t('bianhuanshangxian')">
                <el-input v-model="calPointParams.upperLimit" style="width: 80%;"></el-input>
              </el-form-item>
            </div>
            <div v-if="yt.editObj.calcType == 306">
              <el-form-item :label="$t('kongxiandianbianma')">
                <el-input v-model="calPointParams.idle_point" style="width: 80%;"></el-input>
              </el-form-item>
              <el-form-item :label="$t('gaojingdianbianma')">
                <el-input v-model="calPointParams.event_point" style="width: 80%;"></el-input>
              </el-form-item>
            </div>
            <div v-if="yt.editObj.calcType == 307 || yt.editObj.calcType == 309 || yt.editObj.calcType == 310 || yt.editObj.calcType == 311 || yt.editObj.calcType == 312">
              <el-form-item :label="$t('events')">
                <el-input v-model="calPointParams.events" style="width: 80%;" type="textarea"
                    :rows="5" placeholder='Example：{"24": {"code": "24", "type": 2}, "25": {"code": "25", "type": 1}}'></el-input>
              </el-form-item>
            </div>

            <el-form-item :label="$t('triggers')">
              <el-input v-model="calPointTriggers" style="width: 80%;" type="textarea"
                  :rows="5"></el-input>
            </el-form-item>
          </div>

        </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/iotdm/protocolDetail/update',beforeAdd)" type="primary">
            {{$t('baocun')}}
          </el-button>
        </span>
      </template>

      <!-- 配置协议设备参数 -->
      <template v-if="yt.editObj.action == 'peizhixieyishebeicanshu'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item v-for="(item, index) in paramsTypes" :key="index" :label="$t(item.label)"
            label-width="200px">
            <el-input v-model="paramsTypes[index].protocolDetailCode">
            </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/iotdm/protocolDeviceParam/insertAll',beforeAddParamsTypes)" type="primary">
            {{$t('baocun')}}
          </el-button>
        </span>
      </template>

      <!-- 同步老狗模板 -->
      <template v-if="yt.editObj.action == 'tongbulaogoumuban'">
        <el-table
            ref="multipleTable"
            :data="lgTemplateData"
            tooltip-effect="dark"
            style="width: 100%"
            max-height="300"
            @selection-change="handleSelectionChange">
          <el-table-column
              type="selection"
              width="55">
          </el-table-column>
          <el-table-column
              label="名称"
              prop="name">
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px;margin-buttom:20px">
          <el-button @click="clearTemplateSelection()">取消选择</el-button>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('GET','/web/iotdm/protocolDetail/importLgTemplate',beforeImportTemplate)" type="primary">
            {{$t('baocun')}}
          </el-button>
        </span>
      </template>

    </el-dialog>

  </div>
</template>

<script type="text/javascript">
	// import curd_data from '@/common/curd/curd_data';
	export default {
		/* 唯一命名 */
		name: 'admin_iotdm_protocol_protocol_detail',
    props:{
      protocol:null,
      calPointParams: {},
      calPointTriggers: {},
    },
		data() {
			return {
        paramsTypes: [
          {label: 'zaixianzhuangtai', paramsType: '0',protocolDetailCode:null},
          {label: 'tongdaozhuangtai', paramsType: '1',protocolDetailCode:null},
          {label:'zuihoushangxianshijian',paramsType:'2',protocolDetailCode:null},
          {label:'xinhaoqiangdu',paramsType:'3',protocolDetailCode:null},
          {label:'ICCID',paramsType:'4',protocolDetailCode:null},
          {label:'wangguanSN',paramsType:'5',protocolDetailCode:null}
        ],
				columns: [{
					label: 'xieyimingxibianma',
					prop: 'code'
				}, {
					label: 'xieyimingximingcheng',
					prop: 'name'
				}, {
					label: 'shujuleixing',
					prop: 'dataType',
          type: 'dictionary',
          key: 'EQUIPMENT_TEMPLATE_POINT_DATATYPE'
				}, {
          label: 'shifoujisuanzhi',
          prop:'calculated',
          type: 'bool',
          iln18: ['shi', 'fou']
        },{
					label: 'jisuanleixing',
          prop:'calcType',
          type: 'dictionary',
          key: 'IOTDM_PROTOCOL_CALCTYPE'
				},{
          label: 'jisuancanshu',
          prop:'params'
        }, {
					label: 'caozuo',
					type: 'slot',
					width: 150,
					fixed: 'right'
				}],
        lgTemplateData:[],
			};
		},
		created() {
			setTimeout(() => {
				// table列表接口请求参数
				this.yt.conditions = {
          protocolId: this.protocol.id
				}
				this.yt.get(1);
			}, 300)
		},
		methods: {
			beforeAdd(params, url) {
        if(params.calculated && params.calcType === 0){
          this.utils.errorMessage("请补充计算类型及参数");
          return;
        }
        if (params.calculated) {
          try {

            // 字符串转换为数组
            if (params.calcType == 201 || params.calcType == 304 || params.calcType == 202) {
              if (typeof this.calPointParams.args !== 'string') {
                this.calPointParams.args = this.calPointParams.args.toString();
              }
              this.calPointParams.args = this.calPointParams.args.split(',')
            }
            // 字符串转数值
            if (isNaN(this.calPointParams.factor) && (params.calcType == 101 || params.calcType == 102)) {
              this.calPointParams.factor = parseFloat(this.calPointParams.factor);
            }
            // 一层对象去空
            this.removeEmpty(this.calPointParams);

            // 处理映射
            if (params.calcType == 103) {
              this.calPointParams.map = JSON.parse(this.calPointParams.map)
            }
            // 处理告警
            if (params.calcType == 307 || params.calcType == 309 || params.calcType == 310 || params.calcType == 311 || params.calcType == 312 ) {
              this.calPointParams.events = JSON.parse(this.calPointParams.events)
            }
            var joinParams = {};
            joinParams['params'] = this.calPointParams;
            if (typeof this.calPointTriggers !== 'string') {
              this.calPointTriggers = this.calPointTriggers.toString();
            }
            joinParams['triggers'] = this.calPointTriggers.split(',');

            var finalJson = JSON.stringify(joinParams);
            console.log(finalJson);
          } catch (e) {
            console.log(e)
            this.utils.errorMessage("格式错误");
            return false;
          }
        }
        params.params = finalJson;
				params.protocolId = this.protocol.id
				return params
			},
      beforeAddParamsTypes(params) {
        console.log('iniii')
        for(let i = 0;i<this.paramsTypes.length; i++){
          this.paramsTypes[i].protocolId = this.protocol.id
        }
        params = this.paramsTypes
        return params
      },
      loadParamsType(){
        this.http.get('/web/iotdm/protocolDeviceParam/list?protocolId='+this.protocol.id).then(response => {
          for(let i = 0;i<this.paramsTypes.length; i++){
            for(let j = 0;j<response.data.length; j++){
              if(response.data[j].paramsType == this.paramsTypes[i].paramsType){
                this.paramsTypes[i].protocolDetailCode = response.data[j].protocolDetailCode
              }
            }
          }
        }).catch(error => {
          this.$message.error(error)
        })
      },
      getLgTemplateData(){
        this.http.get('/web/iotdm/protocolDetail/queryAllLgTemplate').then(response => {
          this.lgTemplateData = response.data
        }).catch(error => {
          this.$message.error(error)
        })
      },

      clearTemplateSelection(){
        this.$refs.multipleTable.clearSelection();
      },
      handleSelectionChange (rows) {
        this.selectionKeys = rows.map(item => item.id);
        console.log(this.selectionKeys)
      },
      beforeImportTemplate(params){
        params.protocolId = this.protocol.id;
        params.templateIds = this.selectionKeys;
        return params;
      },
      splitParams(rows){
        if (rows.calcType !== 0){
          var paramsObj = JSON.parse(rows.params);
          this.calPointParams = paramsObj.params;
          this.calPointTriggers = paramsObj.triggers;
          console.log(this.calPointParams)
          if (rows.calcType == 103){
            console.log(paramsObj.params.map);
            this.calPointParams.map = JSON.stringify(paramsObj.params.map);
          }
          if (rows.calcType == 307 || rows.calcType == 309 || rows.calcType == 310 || rows.calcType == 311 || rows.calcType == 312){
            this.calPointParams.events = JSON.stringify(paramsObj.params.events);
          }
        }else{
          this.calPointParams = {};
          this.calPointTriggers = null;
        }
      },
      changeCalcType(value){
        this.calPointParams = {};
        this.calPointTriggers = null;
      },
      removeEmpty(obj) {
        for (let k in obj) {
          let objVal = obj[k];
          console.log(objVal);
          if (objVal === '') delete obj[k];
          else if (objVal.constructor == Object) removeEmpty(objVal);
        }
      }

		}
	};
</script>


<style scoped lang="scss">
	.shift {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
	}
</style>
